module.exports = __webpack_public_path__ + "img/about-img.0e7f733d.png";